import type { AppConfig, ItemType, ItemPriority } from './index';

// Default configuration values
export const DEFAULT_CONFIG: AppConfig = {
  // Branding defaults - none, will show text fallback
  logo_light_url: undefined,
  logo_dark_url: undefined,
  logo_mark_light_url: undefined,
  logo_mark_dark_url: undefined,
  logo_width: 120,
  favicon_url: undefined,
  portal_name: 'Product Portal',

  // Feature flags
  enable_voting: true,
  enable_comments: true,
  enable_projects: true,
  allow_anonymous_submissions: false,

  // Default settings
  default_item_type: 'feedback' as ItemType,
  default_priority: 'medium' as ItemPriority,

  // Tags
  available_tags: [],

  // Notifications
  email_notifications_enabled: true,
  notify_on_new_item: true,
  notify_on_status_change: true,
  notify_on_assignment: true,
};

// Environment banner configuration
export type EnvironmentType = 'development' | 'test' | 'production';

export interface EnvironmentConfig {
  type: EnvironmentType;
  showBanner: boolean;
  bannerText?: string;
  bannerColor?: string;
}

export const ENVIRONMENT_CONFIGS: Record<EnvironmentType, EnvironmentConfig> = {
  development: {
    type: 'development',
    showBanner: false,
  },
  test: {
    type: 'test',
    showBanner: true,
    bannerText: 'TEST ENVIRONMENT - NOT AUTHORIZED FOR PRODUCTION DATA',
    bannerColor: 'bg-warning-500',
  },
  production: {
    type: 'production',
    showBanner: false,
  },
};
